import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';

import * as styles from './BanksList.css';

interface IBanksListProps {
  logos: string[];
  moreCount?: number;
}

export const BanksList: React.FC<IBanksListProps> = ({ logos, moreCount }) => {
  const reversedLogos = React.useMemo(() => [...logos].reverse(), [logos]);
  const hasMore = moreCount && moreCount > 0;

  return (
    <div className={styles['container']}>
      {hasMore && (
        <span className={styles['counter']} data-testid="Counter">
          <UIText1>+{moreCount}</UIText1>
        </span>
      )}
      {reversedLogos.map(logo => (
        <img className={styles['logo']} src={logo} key={logo} alt="" />
      ))}
    </div>
  );
};
